import React, { useState } from "react";
import "./Layout.css";
import Sidemenu from "../Sidemenu/Sidemenu";
import MembershipDetais from "../Page/MembershipDetais/MembershipDetais";
import MittiDetails from "../Page/NewMiti/NewMiti";
import MittiReports from "../Page/MittiReports/MittiReports";
import MittiReportsup from "./../Page/MittiReports -up/MittiReports";
import DisplayDates from "../Page/DisplayDates/DisplayDates";
import Calendarwise from "../Page/display_date2/DisplayDates";
import Setting from "../Page/Setting/Setting";
import Olia from "../Page/Olia/Olia";
import MemberList from "../MemberList/MemberList";
import Outstanding from "../Page/Outstanding_report/Outstanding";
import Display_report from "../Page/Display_dates_report/Display_report";
import Nopage from "../Page/Nopage/Nopage";
import CustomCalendar from "../big_calender/Big_calender";
// import { Route, Routes } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import Hamburger from "../Hamburger/Hamburger";

function Layout() {
  const [update, setupdate] = useState(Date.now());
  return (
    <div className="Layout">
      <div className="Hamburger">
        <Hamburger setupdate={setupdate} />
      </div>
      <div className="Side">
        <Sidemenu setupdate={setupdate} />
      </div>
      <div className="Main">
        <div style={{ padding: "2em" }}>
          <Switch key={update}>
            <Route path="/admin/member" component={MembershipDetais} />
            <Route path="/admin/mittiDetails" component={MittiDetails} />
            <Route path="/admin/mittiReports" component={MittiReportsup} />
            <Route path="/admin/displayDates" component={DisplayDates} />
            <Route path="/admin/allmembers" component={MemberList} />
            <Route path="/admin/Outstanding" component={Outstanding} />
            <Route path="/admin/calender" component={Calendarwise} />
            <Route
              path="/admin/display-date-report"
              component={Display_report}
            />
            <Route path="/admin/olia" component={Olia} />
            <Route path="/admin/setting" component={Setting} />
            <Route path="*" element={<Nopage />} />
          </Switch>
        </div>
      </div>
    </div>
  );
}

export default Layout;
